module.exports = __webpack_public_path__ + "assets/media/agencia-de-consultoria-organizacional.40096676.webm";